<div class="text">
    <h3>Change Log:</h3>
    


    
    30 Mar 2021<br>    
    <li>Add Logos, Logo mamanger, Logo import from AIC</li>
    <li>Import/Export to Excel in the AIC format</li>
    <br><br>

    12 Mar 2021<br>    
    <li>Add Restricted property to Account - update security so restricted accounts are only accessable by users given specific access to account (i.e. they don't count as part of Global or Region)</li>
    <li>Add hover text to grey Account Numbers</li>
    <br><br>

    10 Mar 2021<br>    
    <li>Excel export add other pages</li>        
    <li>Add UserRole text field to the user admin panel</li>
    <li>Show Account name in grey in the drop down if the account has no data</li>
    <br><br>
    

    8 Mar 2021<br>    
    <li>Update layout for the print view, try and fix the overflowed entities</li>        
    <li>Move the change log to bottom menu option - need to add new home page</li>
    <li>Excel export for an account - start</li>
    <br><br>
    
    5 Mar 2021<br>    
    <li>First go at print/save as button</li>        
    <br><br>

    2 Mar 2021<br>    
    <li>Sort the account list, make them all caps</li>        
    <br><br>


    26 Feb 2021<br>    
    <li>Move zoom to new footer and add +,- and fit buttons</li>        
    <br><br>

    25 Feb 2021<br>    
    <li>Add Security access for Read/Write and by Global/Region/Account</li>    
    <li>Add Export to grids</li>    
    <li>Add grid view to main pages</li>    
    <br><br>

    18 Feb 2021<br>    
    <li>Add Help/Info dialog</li>    
    <br><br>

    16 Feb 2021<br>    
    <li>Service Health Assesment View - Add new page with new entitiy view.  Add new fields to version copy and Excel import</li>    
    <li>Reorder Pages</li>    
    <li>Add new fields to Account</li>
    <br><br>

    15 Feb 2021<br>
    <li>Version Dialog - can now create/rename/delete Versions</li>    
    <li>When adding a version, can copy data from the last version</li>    
    <br><br>

    10 Feb 2021<br>
    <li>Support Total Estate/DXC Managed for the ITO Estate section of Asset Map</li>    
    <li>Add Total Estate/DXC Manage to Excel Import</li>    
    <li>Format numbers in Asset Map</li>    
    <li>If Total field is blank then add up fields to get total in Asset Map</li>    
    <br><br>

    9 Feb 2021<br>
    <li>Add Import from Excel</li>    
    <li>Add Versions and start of the version UI</li>    
    <li>Resize the containers on page1 to fit any number of entities</li>    
    <br><br>

    02 Feb 2021<br>
    <li>Add Badges for Client Funding and Tenure of Service</li>    
    <br><br>
    
    28 Jan 2021<br>
    <li>Add editing to Page3</li>    
    <br><br>

    28 Jan 2021<br>
    <li>Test connecting to Azure AS service using end users credentials - add demo page in admin to show connection (was complicated!)</li>
    <li>Layout Page 2</li>
    <li>Build editor for Page 2 elements - click on section and it opens a dialog to edit the values (will look at inline editing later)</li>
    <li>Add WYSWIG editor for Page 2 elements</li>
    <li>Layout Page 3 (no editor yet - vals are hardcoded)</li>
    
    <br><br>
    20 Jan 2021<br>
    <li>Add components to handle generic table Create/Read/Update/Delete</li>
    <li>Add Admin Section with User and Accounts</li>

    <br><br>
    18 Jan 2021<br>
    <li>Use Azure AD Login</li>
    <li>Add Legend</li>
    <li>Add Security/System Support areas</li>


</div>